import { render } from "./TestVideoTracking.vue?vue&type=template&id=5bb30230"
import script from "./TestVideoTracking.vue?vue&type=script&lang=js"
export * from "./TestVideoTracking.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__